import { startOf, toDate } from "@/lib/date-utils"

export const VIEW_TYPES = {
  WEEK: "week",
  MONTH: "month"
}
export const INITIAL_VIEW = VIEW_TYPES.WEEK
export const TODAY = startOf("day")
export const ANIMATION_DIRECTIONS = {
  FORWARD: "forward",
  BACKWARD: "backward"
}
export const INDEXED_DATE_FORMAT = "YYYY-MM-DD"

export const formatDate = date => toDate(date, INDEXED_DATE_FORMAT)

export const CONTEXTS = {
  GLOBAL: {
    id: "global",
    title: ""
  },
  SUBSCRIBER: {
    id: "subscriber",
    title: "For you"
  }
}

export const SCOPE_TYPES = {
  SUBSCRIBER: "subscriber",
  APP: "account_app"
}
